export default __webpack_public_path__ + "static/media/eline.5f77ea82.png";